import React from 'react';
import { connect } from 'react-redux';
import { getAskTheExpertToggleTranslations } from 'selectors/learn/meta';
import LessonRequest from './LessonRequest';
import AskTheExpertToggle from '../../shared/AskTheExpertToggle';

const InsufficientResults = ({ i18n }) => (
  <AskTheExpertToggle i18n={i18n.expertToggle}>
    {({ toggleModal }) => (
      <div className="mb-128">
        <h2 className="fw-b ff-ss">
          {i18n.search.insufficient_results.heading}
        </h2>
        <LessonRequest onClick={toggleModal} />
      </div>
    )}
  </AskTheExpertToggle>
);

const mapStateToProps = state => ({
  i18n: {
    search: state.meta.i18n.learn.search,
    expertToggle: getAskTheExpertToggleTranslations(state),
  },
});

export default connect(mapStateToProps)(InsufficientResults);
